import React, { useState } from "react";
// Selector
import { batch, useSelector } from "react-redux";
import { RaceStatusEnum } from "@tvg/ts-types/Race";
import TalentPicksCard from "@urp/talent-picks/src/components/TalentPicksCard";
import { TalentPickData } from "packages/tvg-lib-ts-types/TalentPicks";
import { getTalentPickBet } from "../../../../store/selectors";

import { Props } from "./types";
import { Container } from "./styled-components";
import { TALENT_PICKS_QA_LABEL } from "../contants";
import { usePlaceBetFromTalentPick } from "../../../../hooks";
import ConfirmModal from "../ConfirmModal";

const TalentPicks = ({
  isBetSlipVisible,
  talentPicks,
  numWagerableRunners
}: Props) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [proceedWithBetSlip, setProcessWithBetSlip] = useState(false);
  const [currentTalentPick, setCurrentTalentPick] =
    useState<TalentPickData | null>(null);

  const { placeTalentPickBet } = usePlaceBetFromTalentPick();

  const talentPickBet = useSelector(getTalentPickBet);

  const afterCloseCallback = () => {
    if (proceedWithBetSlip && currentTalentPick) {
      batch(() => {
        placeTalentPickBet(currentTalentPick);
        setCurrentTalentPick(null);
        setProcessWithBetSlip(false);
      });
    }
  };

  const handleAddToBetslip = (talentPick: TalentPickData) => {
    if (isBetSlipVisible) {
      setShowConfirmModal(true);
      setCurrentTalentPick(talentPick);
    } else {
      placeTalentPickBet(talentPick);
    }
  };

  const handleProceedWithTalentPick = () => {
    if (currentTalentPick) {
      batch(() => {
        setShowConfirmModal(false);
        setProcessWithBetSlip(true);
      });
    }
  };

  const handleCancel = () => {
    batch(() => {
      setCurrentTalentPick(null);
      setShowConfirmModal(false);
    });
  };

  return (
    <>
      <Container data-qa-label={TALENT_PICKS_QA_LABEL.CONTAINER}>
        {talentPicks
          .sort((a, b) => (a.wagerType.id >= b.wagerType.id ? 1 : -1))
          .map((talentPick, i) => (
            <TalentPicksCard
              qaLabel={TALENT_PICKS_QA_LABEL.PICK}
              key={talentPick.id}
              talentPick={talentPick}
              showViewRaceButton={false}
              showAddToBetslipButton={[
                RaceStatusEnum.OPEN,
                RaceStatusEnum.UP_NEXT
              ].includes(talentPick.raceStatus)}
              onAddToBetslip={() => handleAddToBetslip(talentPick)}
              numWagerableRunners={numWagerableRunners}
              cardPosition={i}
            />
          ))}
      </Container>
      <ConfirmModal
        afterCloseCallback={afterCloseCallback}
        title={talentPickBet?.existingModalBet?.title}
        description={talentPickBet?.existingModalBet?.text}
        isOpen={showConfirmModal}
        onConfirm={handleProceedWithTalentPick}
        onCancel={handleCancel}
      />
    </>
  );
};

export default TalentPicks;
